(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce || !('IntersectionObserver' in window)) return;

  var ROOTS = '.ortho-story, .ortho-home, .ortho-pitch, ortho-bodymap, .ortho-statement';
  var SKIP = 'header, .opay, .jdgm-widget, media-gallery, product-media, .product-media-container, [data-om-skip]';
  var BIG = ['pd-studio', 'oh-hero__art', 'oh-lead__art', 'pi-art'];
  var RV = '[data-pdp-section] h2, [data-pdp-section] .ps-lead, .oh-tcard, .pbn-grid li, .obm__row, .opp__close';
  var frames = [];
  var fine = window.matchMedia('(pointer:fine)').matches;
  var raf = 0;

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      e.target.classList.add('om-in');
      io.unobserve(e.target);
    });
  }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });

  /* Safety net: whatever the observer misses is shown anyway. A photo must never stay hidden. */
  function showAll() {
    for (var i = 0; i < frames.length; i++) frames[i].el.classList.add('om-in');
  }

  function prepare(img) {
    if (img.closest(SKIP) || img.dataset.om) return;
    var frame = img.parentElement;
    if (!frame || frame.classList.contains('om-frame')) { img.dataset.om = '1'; return; }
    var rect = img.getBoundingClientRect();
    if (rect.width < 70 || rect.height < 70) return;
    img.dataset.om = '1';
    img.classList.add('om-media');
    frame.classList.add('om-frame');
    var cs = window.getComputedStyle(img);
    var radius = cs.borderRadius && cs.borderRadius !== '0px' ? cs.borderRadius : window.getComputedStyle(frame).borderRadius;
    if (radius && radius !== '0px') frame.style.setProperty('--om-r', radius);
    for (var b = 0; b < BIG.length; b++) {
      if (frame.classList.contains(BIG[b]) || (frame.parentElement && frame.parentElement.classList.contains(BIG[b]))) frame.classList.add('om-kb');
    }
    if (fine) {
      frame.addEventListener('pointermove', tilt);
      frame.addEventListener('pointerleave', untilt);
    }
    io.observe(frame);
    frames.push({ el: frame, img: img });
  }

  /* Staggered reveal for headings, cards and rows, handed to the global reveal observer. */
  function reveal() {
    var els = document.querySelectorAll(RV);
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.dataset.omRv || el.classList.contains('ortho-rv')) continue;
      el.dataset.omRv = '1';
      el.classList.add('ortho-rv');
      var sibs = el.parentElement ? el.parentElement.children : [];
      var n = 0;
      for (var k = 0; k < sibs.length; k++) { if (sibs[k] === el) { n = k; break; } }
      if (n) el.style.setProperty('--d', Math.min(n, 6) * 0.08 + 's');
    }
  }

  function setup() {
    var roots = document.querySelectorAll(ROOTS);
    for (var r = 0; r < roots.length; r++) {
      var imgs = roots[r].querySelectorAll('img');
      for (var i = 0; i < imgs.length; i++) prepare(imgs[i]);
    }
    reveal();
    measure();
    setTimeout(showAll, 2500);
  }

  function tilt(e) {
    var f = e.currentTarget;
    var r = f.getBoundingClientRect();
    var x = (e.clientX - r.left) / r.width - 0.5;
    var y = (e.clientY - r.top) / r.height - 0.5;
    f.style.setProperty('--om-rx', (-y * 5).toFixed(2) + 'deg');
    f.style.setProperty('--om-ry', (x * 6).toFixed(2) + 'deg');
    f.style.setProperty('--om-s', '1.1');
    f.style.setProperty('--om-sx', (x * 34).toFixed(1) + '%');
    f.style.setProperty('--om-sy', (y * 26).toFixed(1) + '%');
  }

  function untilt(e) {
    var f = e.currentTarget;
    f.style.removeProperty('--om-rx');
    f.style.removeProperty('--om-ry');
    f.style.removeProperty('--om-s');
    f.style.setProperty('--om-sx', '0%');
    f.style.setProperty('--om-sy', '0%');
  }

  function measure() {
    var vh = window.innerHeight || 1;
    document.documentElement.style.setProperty('--om-scroll', window.scrollY + 'px');
    for (var i = 0; i < frames.length; i++) {
      var f = frames[i];
      var r = f.el.getBoundingClientRect();
      if (r.bottom < -200 || r.top > vh + 200) continue;
      var p = (r.top + r.height / 2 - vh / 2) / (vh / 2 + r.height / 2);
      if (p > 1) p = 1; else if (p < -1) p = -1;
      f.img.style.setProperty('--om-y', (p * r.height * 0.035).toFixed(1) + 'px');
    }
  }

  function onScroll() {
    if (raf) return;
    raf = requestAnimationFrame(function () { raf = 0; measure(); });
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  document.addEventListener('shopify:section:load', function () { setup(); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup);
  else setup();
  window.addEventListener('load', setup);
})();
